<!-- =========================================================================================
  File Name: Notufy.vue
  Description: Notufy List page
========================================================================================== -->

<template>

  <div id="page-notify-list">

    <vs-prompt
        title="Новое уведомление"
        cancel-text= "Отменить"
        accept-text= "Создать"
        button-cancel = "border"
        @cancel="clearFields"
        @accept="notifyCreateAll"
        @close="clearFields"
        :is-valid="validateForm"
        :active.sync="activePrompt">
        <div>
            <form>

                <div class="vx-row">
                    <div class="vx-col w-full">
                        <vs-input v-validate="'required'" name="title" class="w-full mb-4 mt-2" placeholder="Заголовок" v-model="notifyLocal.header" :color="validateForm ? 'success' : 'danger'" />
                        <vs-textarea rows="5" label="Содержание" v-model="notifyLocal.text" />
                        <vs-select v-model="notifyLocal.type" label="Тип уведомления" class="w-50">
                            <vs-select-item :key="item.value" :value="item.value" :text="item.label" v-for="item in notifyTypeList" />
                        </vs-select>
                    </div>
                </div>

            </form>
        </div>
    </vs-prompt>

    <vx-card ref="filterCard" title="Фильтры" class="notify-list-filters mb-8" actionButtons @refresh="resetColFilters" @remove="resetColFilters">
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Тип</label>
          <v-select :options="typeOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="typeFilter" class="mb-4 md:mb-0" />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Статус</label>
          <v-select :options="stateOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="stateFilter" class="mb-4 md:mb-0" />
        </div>
      </div>
    </vx-card>

    <div class="vx-card p-6">

      <div class="flex flex-wrap items-center">

        <!-- ITEMS PER PAGE -->
        <div>
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ notifyData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : notifyData.length }} of {{ notifyData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>

              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(50)">
                <span>50</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                <span>100</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(250)">
                <span>250</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>


        <!-- ACTION - DROPDOWN -->
        <vs-dropdown vs-trigger-click class="pl-4 pr-4 cursor-pointer flex-shrink">

          <div class="sm:mr-4 p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32">
            <span class="mr-2 leading-none">Действия</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-6 w-6" />
          </div>

          <vs-dropdown-menu>

            <vs-dropdown-item>
              <span class="p-2 flex items-center text-lg text-success" @click="confirmNotifyPublic">
                <feather-icon icon="CheckIcon" svgClasses="h-6 w-6" class="mr-2" />
                <span>Опубликовать</span>
              </span>
            </vs-dropdown-item>

            <vs-dropdown-item>
              <span class="p-2 flex items-center text-lg" @click="gridApi.exportDataAsCsv()">
                <feather-icon icon="SaveIcon" svgClasses="h-6 w-6" class="mr-2" />
                <span>Экспорт CSV</span>
              </span>
            </vs-dropdown-item>

            <vs-dropdown-item>
              <span class="p-2 flex items-center text-lg text-danger" @click="confirmNotifyDelete">
                <feather-icon icon="TrashIcon" svgClasses="h-6 w-6" class="mr-2" />
                <span>Удалить</span>
              </span>
            </vs-dropdown-item>

          </vs-dropdown-menu>
        </vs-dropdown>


        <div class="flex-shrink">
          <vs-button type="border" color="success" icon-pack="feather" icon="icon-plus" class="mr-4" @click="confirmNotifyCreateAll">Создать для всех</vs-button>
        </div>
        
        <!-- <div class="flex-shrink">
          <vs-button type="border" color="success" icon-pack="feather" icon="icon-plus" class="mr-4" @click="notifyCreateSim">Создать для SIM-карты</vs-button>
        </div> -->

        <div class="flex-grow">
          <vs-button type="border" color="primary" icon-pack="feather" icon="icon-refresh-cw" class="mr-4" @click="notifyUpdate">Обновить</vs-button>
        </div>


        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <vs-input class="mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Поиск..." />
        <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->


      </div>


      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="notifyData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="false"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl">
      </ag-grid-vue>

      <vs-pagination
        :total="totalPages"
        :max="7"
        v-model="currentPage" />

    </div>

  </div>

</template>

<script>
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'

// Store Module
import moduleClient from '@/store/client/moduleClient.js'
import moduleNotify from '@/store/notify/moduleNotify.js'

// Cell Renderer
import CellRendererClient from "./cell-renderer/CellRendererClient.vue"
import CellRendererType from "./cell-renderer/CellRendererType.vue"
import CellRendererState from "./cell-renderer/CellRendererState.vue"


export default {
  components: {
    AgGridVue,
    vSelect,

    // Cell Renderer
    CellRendererClient,
    CellRendererType,
    CellRendererState,
  },
  data() {
    return {

      stateFilter: { label: 'Все', value: 'all' },
      stateOptions: [],

      typeFilter: { label: 'Все', value: 'all' },
      typeOptions: [],

      searchQuery: "",

      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        suppressMovable: true,
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: 'ID',
          field: 'notid',
          width: 110,
          filter: true,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
        },
        {
          headerName: 'Статус',
          field: 'state',
          filter: true,
          width: 140,
          cellRendererFramework: 'CellRendererState',
        },
        {
          headerName: 'Клиент',
          field: 'clid',
          filter: true,
          width: 140,
          cellRendererFramework: 'CellRendererClient'
        },
        {
          headerName: 'Тип',
          field: 'type',
          filter: true,
          width: 150,
          cellRendererFramework: 'CellRendererType',
        },
        {
          headerName: 'Заголовок',
          field: 'header',
          filter: true,
          width: 200,
        },
        {
          headerName: 'Текст',
          field: 'text',
          // filter: true,
          width: 450,
        },
        {
          headerName: 'Создано',
          field: 'time_create',
          // filter: true,
          width: 190,
        },
        {
          headerName: 'Обновлено',
          field: 'time_update',
          // filter: true,
          width: 190,
        },
      ],

      activePrompt: false,

      notifyLocal: {
        header: "",
        text: "",
        type: 0,
      },
      notifyTypeList: moduleNotify.notifyTypeList,


      // Cell Renderer Components
      components: {
        CellRendererClient,
        CellRendererType,
        CellRendererState,
      }
    }
  },
  watch: {
    stateFilter(obj) {
      this.setColumnFilter("state", obj.value)
    },
    typeFilter(obj) {
      this.setColumnFilter("type", obj.value)
    },
  },
  computed: {
    // programs_data() {
    //   return this.$store.state.notify.programs
    // },
    notifyData() {
      // return this.$store.state.notify.notify
      return this.$store.getters["notify/getNotify"]
    },
    paginationPageSize() {
      if(this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages() {
      if(this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get() {
        if(this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    },
    validateForm() {
        return !this.errors.any() && this.notifyLocal.header != '' && this.notifyLocal.text != ''
    }
  },
  methods: {
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if(val !== "all") {
        modelObj = { type: "equals", filter: val }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.typeFilter = this.stateFilter = { label: 'Все', value: 'all' }

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val)
    },
    notifyUpdate() {
      this.$store.dispatch("notify/fetchNotify")
      .then(() => {
        this.updateSearchQuery(this.searchQuery)
        // сбрасываем фильтры, иначе нужно найти способ обновить таблицу согласно выбранным фильтрам
        this.typeFilter = this.stateFilter = { label: 'Все', value: 'all' }
      })
    },

    confirmNotifyPublic() {
      if (this.gridApi.getSelectedRows().length) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Публикация уведомления`,
          text: `Вы действительно хотите опубликовать выбранные уведомления (количество: ${this.gridApi.getSelectedRows().length})?`,
          accept: this.notifyPublic,
          acceptText: "Опубликовать",
          cancelText: "Отмена"
        })
      } else {
        this.$vs.dialog({
          color: 'primary',
          title: `Публикация уведомления`,
          text: `Выберите из списка уведомления, которые хотите опубликовать.`,
          acceptText: "Ок",
        })
      }
    },
    notifyPublic() {
      this.$store.dispatch("notify/publicNotify", this.gridApi.getSelectedRows())
        .then(() => { this.notifyUpdate() })
    },

    confirmNotifyDelete() {
      if (this.gridApi.getSelectedRows().length) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Удаление уведомления`,
          text: `Вы действительно хотите удалить выбранные уведомления (количество: ${this.gridApi.getSelectedRows().length})?`,
          accept: this.notifyDelete,
          acceptText: "Удалить",
          cancelText: "Отмена"
        })
      } else {
        this.$vs.dialog({
          color: 'primary',
          title: `Удаление уведомления`,
          text: `Выберите из списка уведомления, которые хотите опубликовать.`,
          acceptText: "Ок",
        })
      }
    },
    notifyDelete() {
      this.$store.dispatch("notify/deleteNotify", this.gridApi.getSelectedRows())
        .then(() => { this.notifyUpdate() })
    },

    confirmNotifyCreateAll() {
      this.activePrompt = true
    },
    notifyCreateAll() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$store.dispatch('notify/createNotifyAll', Object.assign({}, this.notifyLocal))
          this.clearFields()
        }
      })
    },

    notifyCreateSim() {

    },
    clearFields() {
      Object.assign(this.notifyLocal, {
        header: "",
        text: "",
        type: 0,
      })
    },
  },
  mounted() {
    this.gridApi = this.gridOptions.api

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if(this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(".ag-header-container")
      header.style.left = "-" + String(Number(header.style.transform.slice(11,-3)) + 9) + "px"
    }
  },
  created() {
    if (!moduleClient.isRegistered) {
      this.$store.registerModule('client', moduleClient)
      moduleClient.isRegistered = true
    }
    this.$store.dispatch("client/fetchClients")

    if (!moduleNotify.isRegistered) {
      this.$store.registerModule('notify', moduleNotify)
      moduleNotify.isRegistered = true
    }


    this.notifyUpdate()

    // this.$store.dispatch("notify/fetchNotify")
    // .then(() => {
    //   let notid = this.$route.params.notifyId
    //   if (notid) {
    //     this.searchQuery = notid
    //     this.updateSearchQuery(notid)
    //   }
    // })

    this.typeOptions = Object.assign([], moduleNotify.notifyTypeList)
    this.typeOptions.unshift({ label: 'Все', value: 'all' })
    this.stateOptions = Object.assign([], moduleNotify.notifyStateList)
    this.stateOptions.unshift({ label: 'Все', value: 'all' })
  },
}

</script>

<style lang="scss">
#page-notify-list {
  .ag-theme-material .ag-cell {
    padding-right: 10px;
  }
  .vs__selected-options {
    max-width: 100%;
  }
  .vs__selected {
    white-space: nowrap;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 85%;
  }
  .notify-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>
